import * as ui from '../ui.js'
import { subDays, subMonths, format, compareAsc, parseISO } from 'date-fns'
import { formatHtmlDateInput, isValidDateRange, getToday, isSameDate } from '../utilities/dates.js'
import * as domUtilities from '../utilities/dom.js'
import * as store from '../data/store.js'

let availableTime = 0
let availableTimeUnit = 'days'
let lastRefreshDate

export async function initializeReportDates(reportForm){
    // TODO - use this approach for shipment date ranges
    availableTime = Number(reportForm.dataset.availableTime)
    availableTimeUnit = reportForm.dataset.availableTimeUnit

    lastRefreshDate = store.getDataRefreshDate()

	if (document.getElementById('effectiveDate') != null){
		initializeEffectiveDate()
	} else if(document.getElementById('startDate') != null){
		initializeDateRanges()
	}
}

function initializeDateRanges() {
    initializeDateRangeButtonGroup()
    initializeDateRangeSelects()
}


function calculatePresetDateRanges(element) {
    const days = element.dataset.days
	const ago = subDays(lastRefreshDate, days)
    const startDate = JSON.stringify({ start: ago })
	const endDate = JSON.stringify({ end: new Date(lastRefreshDate) })

    element.dataset.startDate = startDate
    element.dataset.endDate = endDate
}

export function initializeDateRangeButtonGroup() {
    const buttonGroup = document.getElementById('js-date-range')
    buttonGroup.addEventListener('click', activatePresetDateRange)

    const dateRangeGroup = document.querySelectorAll('[data-days]')

    dateRangeGroup.forEach(calculatePresetDateRanges)

    dateRangeGroup[0].click()
}

export function initializeDateRangeSelects() {
    const endElement = document.getElementById('endDate')
    const startElement = document.getElementById('startDate')

	const max = format(lastRefreshDate, 'yyyy-MM-dd')
    endElement.max = max
    startElement.max = max

	const limit = subDays(lastRefreshDate, availableTime)
    const min = format(limit, 'yyyy-MM-dd')
    startElement.min = min
    endElement.min = min

    // Needs to be click or manual change, not any change
    // Clicking a date range button will change this value
    //startElement.addEventListener('change', clearDateRangeButtonGroup)
    startElement.addEventListener('change', validateDateRange)
    endElement.addEventListener('change', validateDateRange)
}

/**
 *
 *  Compares a custom date range to preset ranges and
 *  modfies button group style accordingly
 *
 */
export function usesPresetDateRange({ start, end }) {
    const dateRangeGroup = document.querySelectorAll('[data-days]')

    // TODO - query for that class then remove it
    dateRangeGroup.forEach((g) => g.classList.remove('mt-btn--active'))

    const selectedStart = JSON.stringify({ start })
    const selectedEnd = JSON.stringify({ end })

    const startButton = document.querySelector(
        `button[data-start-date='${selectedStart}'`
    )
    const usesSameEnd =
        startButton?.dataset.endDate === selectedEnd ? true : false

    if (usesSameEnd) {
        startButton.classList.add('mt-btn--active')
    }
}

// TODO - re-architect date ranges
// There's too much duplicated code
function activatePresetDateRange(e) {
    const element = e.srcElement
    const startDate = JSON.parse(element.dataset.startDate)
    const endDate = JSON.parse(element.dataset.endDate)

    ui.removeReport()

    const siblings = domUtilities.getSiblings(element)
    siblings.forEach((s) => s.classList.remove('mt-btn--active'))

    setDateRangeStart(new Date(startDate.start))
    setDateRangeEnd(new Date(endDate.end))

    element.classList.add('mt-btn--active')
}

function validateDateRange() {
    ui.removeReport()
    const endElement = document.getElementById('endDate')
    const startElement = document.getElementById('startDate')
    const start = parseISO(startElement.value)
    const end = parseISO(endElement.value)

    const isValidStart = isValidDateRange({ start, end })

    if (!isValidStart) setDateRangeEnd(start)

    usesPresetDateRange({ start, end })
}

 function initializeEffectiveDate() {
    const effectiveElement = document.getElementById('effectiveDate')

	const max = format(lastRefreshDate, 'yyyy-MM-dd')
    effectiveElement.max = max
	let available
	
	if (availableTimeUnit == 'months'){
		available = subMonths(lastRefreshDate, availableTime)
	} else{
		available = subDays(lastRefreshDate, availableTime)
	}

    const min = format(available, 'yyyy-MM-dd')
    effectiveElement.min = min

	setEffectiveDate(lastRefreshDate)
}

function setDateRangeStart(d) {
    const startDate = document.getElementById('startDate')
    startDate.value = formatHtmlDateInput(d)
}

function setDateRangeEnd(d) {
    const endDate = document.getElementById('endDate')
    endDate.value = formatHtmlDateInput(d)
}

function setEffectiveDate(d) {
    const effectiveElement = document.getElementById('effectiveDate')
    effectiveElement.value = formatHtmlDateInput(d)
}
